var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.286 18.94a.633.633 0 0 0-.622.644v6.63c0 .827-.651 1.5-1.452 1.5H3.696c-.8 0-1.452-.673-1.452-1.5V3.786c0-.827.651-1.5 1.452-1.5h14.516c.8 0 1.452.673 1.452 1.5v6.63c0 .355.278.643.622.643a.633.633 0 0 0 .622-.643v-6.63C20.908 2.25 19.698 1 18.212 1H3.696C2.209 1 1 2.25 1 3.786v22.428C1 27.75 2.21 29 3.696 29h14.516c1.487 0 2.696-1.25 2.696-2.786v-6.63a.633.633 0 0 0-.622-.643zm10.67-4.175-.003-.009a.638.638 0 0 0-.138-.213l-5.96-6.159a.608.608 0 0 0-.88 0 .658.658 0 0 0 0 .909l4.9 5.064H9.225a.633.633 0 0 0-.622.643c0 .355.279.643.622.643h19.651l-4.901 5.064a.658.658 0 0 0 0 .91.61.61 0 0 0 .88 0l5.963-6.162.001-.002a.641.641 0 0 0 .134-.208l.003-.011A.665.665 0 0 0 31 15V15a.67.67 0 0 0-.045-.235z",
    fill: "#243F59",
    fillRule: "nonzero",
    stroke: "#243F59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7167a683f4b724b4c0ea8205240b9f94.svg";
export { ForwardRef as ReactComponent };